<div class="container-fluid px-3">
    <app-list-devices/>
  </div>